import "./Sidebar.css";
import { useEffect, useState } from "react";
import { ProSidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { Box, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import "react-pro-sidebar/dist/css/styles.css";
import { tokens } from "../../theme";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import DirectionsBusFilledIcon from "@mui/icons-material/DirectionsBusFilled";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import FlagCircleIcon from "@mui/icons-material/FlagCircle";
import ConnectWithoutContactIcon from "@mui/icons-material/ConnectWithoutContact";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import RestorePageIcon from "@mui/icons-material/RestorePage";
import MemoryIcon from "@mui/icons-material/Memory";
import GavelIcon from "@mui/icons-material/Gavel";
import ShuffleIcon from "@mui/icons-material/Shuffle";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DevicesOtherIcon from "@mui/icons-material/DevicesOther";
import LineWeightIcon from "@mui/icons-material/LineWeight";
import CreateNewFolderIcon from "@mui/icons-material/CreateNewFolder";
import ManageHistoryIcon from "@mui/icons-material/ManageHistory";
import OnDeviceTrainingIcon from "@mui/icons-material/OnDeviceTraining";
import ModelTrainingIcon from "@mui/icons-material/ModelTraining";
import PlaylistAddCircleIcon from '@mui/icons-material/PlaylistAddCircle';import AddCircleIcon from '@mui/icons-material/AddCircle';
import AddTaskIcon from '@mui/icons-material/AddTask';
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import TodayIcon from "@mui/icons-material/Today";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import { Avatar } from "antd";
import WebIcon from "@mui/icons-material/Web";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import EvmLogo from "./../../../assets/images/evm_logo.png";
import RoomPreferencesIcon from "@mui/icons-material/RoomPreferences";
import MapsHomeWorkSharpIcon from "@mui/icons-material/MapsHomeWorkSharp";
import PasswordIcon from "@mui/icons-material/Password";
import DummyProfilePic from "./../../../assets/images/dummy_user_photo.jpg";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import SaveAsIcon from "@mui/icons-material/SaveAs";
import ViewListIcon from "@mui/icons-material/ViewList";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import BallotIcon from "@mui/icons-material/Ballot";
import ExploreIcon from "@mui/icons-material/Explore";
import HistoryIcon from '@mui/icons-material/History';
import SettingsSuggestIcon from "@mui/icons-material/Settings";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import AssessmentIcon from "@mui/icons-material/Assessment";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import DriveFileRenameOutlineRoundedIcon from "@mui/icons-material/DriveFileRenameOutlineRounded";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import HowToVoteIcon from "@mui/icons-material/HowToVote";
import Battery0BarIcon from "@mui/icons-material/Battery0Bar";
import BatteryAlertIcon from "@mui/icons-material/BatteryAlert";
import BatterySaverIcon from "@mui/icons-material/BatterySaver";
import InventoryIcon from '@mui/icons-material/Inventory';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import RuleFolderIcon from '@mui/icons-material/RuleFolder';
import AddCardIcon from '@mui/icons-material/AddCard';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import BuildCircleIcon from '@mui/icons-material/BuildCircle';
import SendTimeExtensionIcon from '@mui/icons-material/SendTimeExtension';
import PostAddOutlinedIcon from '@mui/icons-material/PostAddOutlined';
import PreviewOutlinedIcon from '@mui/icons-material/PreviewOutlined';
import ListOutlinedIcon from '@mui/icons-material/ListOutlined';
import OpenInBrowserIcon from '@mui/icons-material/OpenInBrowser';
import NotListedLocationIcon from '@mui/icons-material/NotListedLocation';
import PreviewIcon from '@mui/icons-material/Preview';
import environments from '../../../config';
import VisibilityIcon from '@mui/icons-material/Visibility';


const Item = ({ title, to, icon, selected, setSelected }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <MenuItem
      active={selected === title}
      style={{
        color: colors.grey[100],
        width: '310px'
      }}
      onClick={() => setSelected(title)}
      icon={icon}
    >
      <Typography sx={{ fontWeight: "bold" }}>{title}</Typography>
      <Link to={to} />
    </MenuItem>
  );
};

const Sidebar = ({isSidebar,setIsSidebar}) => {
  // var Role = localStorage.getItem("Role");
  const [currentUserDetails] = useState(
    JSON.parse(window.sessionStorage.getItem("currentUserDetails"))
  );
  const [visible, setVisible] = useState(false);
  const theme = useTheme();
  const [maintaskcode, setmaintaskcode] = useState([]);
  const [subtaskcodes, setsubtaskcodes] = useState([]);
  const colors = tokens(theme.palette.mode);
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [selected, setSelected] = useState("Dashboard");
  // const username = window.sessionStorage.getItem("currentUserDetails");
  const mainTasks = JSON.parse(localStorage.getItem("main_task"));
  const subTasks = JSON.parse(localStorage.getItem("sub_tasks"));
  var code = [];
  var subcode = [];
  // const [toggled, setToggled] = useState(false);
  console.log(subtaskcodes)

  const userId = window.sessionStorage.getItem("sessionToken");
  // const stateId = userId.substring(0, 2);
  // const districtId = userId.substring(2, 5);
  const userRole = userId.substring(11, 8);
  const stateId = userId.substring(0, 2);
  const [CurrImage, setCurrImage] = useState("");

  async function getCurrImage() {
    try {
      await fetch(`${process.env.REACT_APP_API}/user/getProfilePicture`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          userID: userId,
        }),
        // mode: "cors"
      })
        .then((resp) => resp.json())
        .then((data) => {
          if (data.data !== "" || data.data !== undefined) {
            setCurrImage(String(data.data));
          }
        });
      //	 const data = await response.json();
    } catch (error) {
      // alert({ error });
    }
  }
  useEffect(() => {
    getCurrImage();
    mainTasks[0].forEach((ele) => {
      code.push(ele.split(":")[0]);
      setmaintaskcode(...maintaskcode, code);
    }, []);

    subTasks.forEach((element) => {
      subcode.push(String(element).split(":")[0]);
      setsubtaskcodes(...subtaskcodes, subcode);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // //console.log(currentUserDetails);

  // ////console.log(subtaskcodes,"....");
  //   const handleCollapsedChange = () => {
  //     setCollapsed(!collapsed);
  //   };
  //   const handleToggleSidebar = (value) => {
  //     setToggled(value);
  //   };

  let ribbonText = "";  // Default value
  const currentUrl = window.location.href;

  for (const env in environments) {
    if (currentUrl.includes(environments[env].url)) {
      ribbonText = environments[env].ribbonText;
      break;
    }
  }

  console.log(isSidebar)

  return (
    <Box
      id="sidenav"
      onMouseOver={() =>{
        setIsCollapsed(false)
        setIsSidebar(true)
      } 
      }
      onMouseLeave={() =>{
        setIsCollapsed(true) 
        setIsSidebar(false)
      }}
      sx={{
        "& .pro-sub-menu-inner": {
          background: `${colors.primary[400]} !important`,
          color: "#6870fa !important",
        },
        "& .MuiBox-root css-0": {
          fontWeight: "bold",
        },
        "& .MuiBox-root.css-1l8icbj": {
          padding: "0px 0px 0px 10px",
        },
        "& .pro-sub-menu": {
          //padding: "5px 35px 5px 20px !important",
          color: `${colors.grey[300]}!important`,
          fontWeight: "bold",
        },
        "& .pro-sub-menu-inner:hover": {
          color: "#fafafa !important",
          background: `${colors.primary[500]} !important`,
          fontWeight: "bold",
        },
        "& .pro-item-content:hover": {
          //----------------- for hover text color in sidebar ----------
          // "& .pro-sub-menu:inactive":{
          color: "#fafafa !important",
          fontWeight: "bold",
          /// background: `${colors.primary[500]} !important`,
        },
        "& .pro-item-content.active": {
          //----------------- for hover text color in sidebar ----------
          // "& .pro-sub-menu:inactive":{
          backgroundColor: `#3E54AC !important`,
          color: "#3E54AC !important",
          fontWeight: "bold",
          /// background: `${colors.primary[500]} !important`,
        },

        "& .pro-sub-menu.active": {
          color: "#fafafa !important",
          fontWeight: "bold",

          //background: `${colors.primary[500]} !important`,
        },
        "& .pro-sidebar-inner": {
          background: `${colors.primary[400]} !important`,
          fontWeight: "bold",
          // position: isCollapsed === false ? 'fixed' : "" ,
        },
        "& .pro-icon-wrapper": {
          backgroundColor: "transparent !important",
          fontWeight: "bold",
        },
        // for inner icons
        "& .pro-inner-item": {
          padding: "5px 35px 5px 10px !important",
          color: "#090F25 !important",
          fontWeight: "bold",
        },
        "& div.pro-inner-item > : first-child :hover": {
          color: "#fafafa !important",
          borderRadius: "5px",
          cursor: "none",
          backgroundColor: "",
        },
        "& .pro-inner-item:hover": {
          color: "#fafafa !important",
          borderRadius: "5px",
          backgroundColor: `#090F25 !important`,
        },

        "& .pro-inner-item .pro-menu-item": {
          color: "#090F25 !important",
          fontWeight: "bold",
        },
        // home icon
        "& .pro-menu-item.active": {
          color: "#090F25 !important",
        },
      }}
    >
      <ProSidebar collapsed={isCollapsed} width="320px">
        {
        isSidebar && ribbonText !== "" ?(
          <Box className="sidebar-ribbon">{ribbonText}</Box>
        ): ""
      }
        <Menu iconShape="square">
          {/* LOGO AND MENU ICON */}

          {!isCollapsed ? (
            <>
              {/* <MenuItem
              onClick={() => setIsCollapsed(!isCollapsed)}
              icon={<MenuOutlinedIcon />}
              style={{
                margin: "10px 0 20px 0",
              }}
              ></MenuItem> */}
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                ml="15px"
              >
                <img
                  alt="profile-user"
                  width="150"
                  height="auto"
                  margin="50px 0"
                  padding="0px 50px"
                  src={EvmLogo}
                  style={{
                    cursor: "pointer",
                    borderRadius: "5%",
                    justifyContent: "center",
                  }}
                />
              </Box>
            </>
          ) : (
            <MenuItem
              // onClick={() => setIsCollapsed(!isCollapsed)}
              icon={isCollapsed ? <MenuOutlinedIcon /> : undefined}
              style={{
                margin: "10px 0 20px 0",
              }}
            ></MenuItem>
          )}
          {!isCollapsed && (
            <Box mb="25px">
              <Box display="flex" justifyContent="center" alignItems="center">
                <Avatar
                  src={CurrImage !== "" ? CurrImage : DummyProfilePic}
                  style={{
                    cursor: "pointer",
                    borderRadius: "50%",
                    width: "100px",
                    height: "100px",
                  }}
                />
              </Box>
              <br />
              <Box textAlign="center">
                <Typography fontWeight="bold" color="primary">
                  {" "}
                  {currentUserDetails.userId}
                </Typography>
              </Box>
            </Box>
          )}
          <Box paddingLeft={isCollapsed ? undefined : "10%"}>
            {(subtaskcodes.includes("53") === true) ? (
              <Item
                title="Dashboard"
                to="/home"
                icon={<HomeOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
              />
            ) : (subtaskcodes.includes("73") === true)?
            (
              <Item
                title="RO-Dashboard"
                to="/RODashBoard"
                icon={<HomeOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
              />
            ):(
              <Item
                title="Manufacturer-Dashboard"
                to="/manufacturerdashboard"
                icon={<HomeOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
              />
            )
            }
            {/* <Item
                title="RODashBoard"
                to="/RODashBoard"
                icon={<HomeOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
              /> */}
            {maintaskcode.includes("1") === true ? (userRole !== "ARO") ? (
              <SubMenu
                title="User Management"
                to="/UserManagement"
                selected={selected}
                setSelected={setSelected}
                icon={<PersonOutlinedIcon />}
              >
                {subtaskcodes.includes("1") === true ? (
                  <Item
                    title="Create User"
                    to="/createuser"
                    icon={<PersonOutlinedIcon />}
                    selected={selected}
                    setSelected={setSelected}
                  />
                ) : (
                  ""
                )}
                {subtaskcodes.includes("2") === true ? (
                  (userRole ==='ROP'|| userRole === 'ROA') ? "" :
                  <Item
                    icon={<MapsHomeWorkSharpIcon />}
                    title="User List"
                    to="/UserList/UserList"
                    selected={selected}
                    setSelected={setSelected}
                  />
                ) : (
                  ""
                )}
                {subtaskcodes.includes("5") === true ? (
                  <Item
                    title="Change Password"
                    to="/changepassword"
                    icon={<PasswordIcon />}
                    selected={selected}
                    setSelected={setSelected}
                  />
                ) : (
                  ""
                )}
                {subtaskcodes.includes("4") === true ? (
                  <Item
                    icon={<TodayIcon />}
                    title="Roles and Permissions"
                    to="/RolesPermissions"
                    selected={selected}
                    setSelected={setSelected}
                  />
                ) : (
                  ""
                )}
              </SubMenu>
            ) : ""  : (
              ""
            )}

            {maintaskcode.includes("4") === true ? (
              <SubMenu
                title="WH & SR Management"
                selected={selected}
                setSelected={setSelected}
                icon={<WarehouseIcon />}
              >
                {subtaskcodes.includes("36") === true ? (
                  <Item
                    icon={<MapsHomeWorkSharpIcon />}
                    title="Create WH/SR "
                    to="/warehouseManagement/Create"
                    selected={selected}
                    setSelected={setSelected}
                  />
                ) : (
                  ""
                )}
                {subtaskcodes.includes("37") === true ? (
                   (userRole ==='ROP'|| userRole === 'ROA' || userRole === "ARO") ? "" :
                  <Item
                    icon={<MapsHomeWorkSharpIcon />}
                    title="View/Edit WH "
                    to="/warehouseManagement/Warehouse"
                    selected={selected}
                    setSelected={setSelected}
                  />
                ) : (
                  ""
                )}
                {userRole !== "MFA" ? 
                  subtaskcodes.includes("37") === true ? (
                    <Item
                      icon={<RoomPreferencesIcon />}
                      title="View/Edit SR"
                      to="/warehouseManagement/Strong Room"
                      selected={selected}
                      setSelected={setSelected}
                    />
                  ) : (
                    ""
                  ) : ""
                }
               {(subtaskcodes.includes("40") === true  )? (
                  <Item
                    icon={<RoomPreferencesIcon />}
                    title="Approval "
                    to="/warehouseManagement/Approval"
                    selected={selected}
                    setSelected={setSelected}
                  />
                ) : (
                  ""
                )}
              </SubMenu>
            ) : (
              ""
            )}

            {maintaskcode.includes("3") === true ? (
              <SubMenu
                title="Order Management"
                selected={selected}
                setSelected={setSelected}
                icon={<WebIcon />}
              >
                {subtaskcodes.includes("31") === true ? (
                  <Item
                    icon={<AddCardIcon />}
                    title="New Procurement"
                    to="/procurement"
                    selected={selected}
                    setSelected={setSelected}
                  />
                ) : (
                  ""
                )}

                {subtaskcodes.includes("27") === true ? (
                  <Item
                    icon={<CreateNewFolderIcon />}
                    title="Create Order "
                    to="/createorder"
                    selected={selected}
                    setSelected={setSelected}
                  />
                ) : (
                  ""
                )}

                { subtaskcodes.includes("69") === true ? (
                  <Item
                    icon={<TodayIcon />}
                    title="Active Orders"
                    to="/OrderGeneration"
                    selected={selected}
                    setSelected={setSelected}
                  />
                  
                ) : (
                  ""
                )}
                { subtaskcodes.includes("69") === true ? (
                  <Item
                    icon={<TodayIcon />}
                    title="All Orders"
                    to="/OrderGenerationAll"
                    selected={selected}
                    setSelected={setSelected}
                  />
                  
                ) : (
                  ""
                )}  
 {console.log("tests")}
                {(subtaskcodes.includes("30") === true && (userRole !== "ADM" || userRole !== "ECI" || userRole !== "ECU" || userRole !== "ESU")) ? (
                    <Item
                      icon={<LineWeightIcon />}
                      title="Allocate Orders"
                      to="/Allocation"
                      selected={selected}
                      setSelected={setSelected}
                    />
                  ) : (
                    ""
                  )}

                {subtaskcodes.includes("29") === true ? (
                  <Item
                    icon={<RuleFolderIcon />}
                    title="Approve / Decline Orders"
                    to="/approveorders"
                    selected={selected}
                    setSelected={setSelected}
                  />
                ) : (
                  ""
                )}

                {(subtaskcodes.includes("35") === true && (userRole === "CEO" || userRole === "COF" || userRole === "SNO") ) ? (
                  <Item
                    icon={<CompareArrowsIcon />}
                    title="Merge Order"
                    to="/mergeorder"
                    selected={selected}
                    setSelected={setSelected}
                  />
                ) : (
                  ""
                )}

                {(subtaskcodes.includes("31") === true) ? (
                  <SubMenu
                    title="Physical Verification"
                    to="/physicalverification"
                    selected={selected}
                    setSelected={setSelected}
                    icon={<DocumentScannerIcon />}
                  >
                    <Item icon={<ViewListIcon />} title="View Physical Verification" to="/physicalverification" selected={selected} setSelected={setSelected}/>
                    {
                      (userRole === "ADM") &&
                       <Item
                        icon={<SaveAsIcon />}
                        title="Create PV"
                        to="/physicalverification/createphysicalverification"
                        selected={selected}
                        setSelected={setSelected}
                      />
                    }
                   
                  </SubMenu>
                ) : (
                  ""
                )}
                
                {(subtaskcodes.includes("30") === true && userRole === "MWM") ? (
                  <Item
                    icon={<QrCodeScannerIcon />}
                    title="New/Repaired Stock Entry"
                    to="/stockentry"
                    selected={selected}
                    setSelected={setSelected}
                  />
                ) : (
                  ""
                )}

                

                {/* {subtaskcodes.includes("27") === true ? (
                  <Item
                    icon={<InventoryIcon  />}
                    title="Stock Orders"
                    to="/stockorders"
                    selected={selected}
                    setSelected={setSelected}
                  />
                ) : (
                  ""
                )} */}

                
                {subtaskcodes.includes("71") === true ? (
                  <Item
                    icon={<AssignmentTurnedInIcon />}
                    title="Completed Orders"
                    to="/completedorders"
                    selected={selected}
                    setSelected={setSelected}
                  />
                ) : (
                  ""
                )}
                {/* <Item
                  icon={<TravelExploreIcon />}
                  title="Roll Back"
                  to="/RollBacking"
                  selected={selected}
                  setSelected={setSelected}
                /> */}

                {userRole === "MFA" || 
                 userRole === "MOF" ||
                 userRole === "MFS" ||
                 userRole === "MWM" ? (
                 <Item
                icon={<ManageHistoryIcon />}
                title="Roll Back"
                to="/MoveWHtoWHUnits"
                selected={selected}
                setSelected={setSelected}
                />
                 ) : (
                    ""
                  )}
                  {userRole === "MFA" || 
                 userRole === "MOF" ||
                 userRole === "MFS" ||
                 userRole === "MWM" ? (
                 <Item
                icon={<ManageHistoryIcon />}
                title="National Reserve (Status Change)"
                to="/NRVRollback"
                selected={selected}
                setSelected={setSelected}
                />
                 ) : (
                    ""
                  )}
                  {
                    userRole !== "MFA" || 
                    userRole !== "MOF" ||
                    userRole !== "MFS" ||
                    userRole !== "MWM" ? (
                    <Item
                    icon={<TravelExploreIcon />}
                    title="Order RollBack"
                    to="/OrderRollBack"
                    selected={selected}
                    setSelected={setSelected}
                  />
                    ):""
                  }
                   {
                    userRole !== "MFA" || 
                    userRole !== "MOF" ||
                    userRole !== "MFS" ||
                    userRole !== "MWM" ? (
                    <Item
                    icon={<TravelExploreIcon />}
                    title="Unit Order RollBack"
                    to="/UnitOrderRollBack"
                    selected={selected}
                    setSelected={setSelected}
                  />
                    ):""
                  }
                  
                <Item
                  icon={<TravelExploreIcon />}
                  title="Unit order Search"
                  to="/UnitOrderSearch"
                  selected={selected}
                  setSelected={setSelected}
                />
                <Item
                  icon={<TravelExploreIcon />}
                  title="Check Transport Status"
                  to="/CheckTransportStatus"
                  selected={selected}
                  setSelected={setSelected}
                />
                
                
              </SubMenu>
            ) : (
              ""
            )}

            {maintaskcode.includes("2") === true ? (
              <SubMenu
                title="Unit Management"
                to="/Unitmanagement"
                selected={selected}
                setSelected={setSelected}
                icon={<AccountTreeIcon />}
              >
              {subtaskcodes.includes("11") === true ? (
                    <Item
                      icon={<TodayIcon />}
                      title="Election Schedule "
                      to="/electionschedule"
                      selected={selected}
                      setSelected={setSelected}
                    />
                  ) : (
                    ""
                  )}
                  {userRole !== "ADM" ? userRole === "ARO" ? "" : (
                <SubMenu title="FLC" icon={<MemoryIcon />}>
                
                  {/* <Item
                      icon={<TodayIcon />}
                      title="View FLC List "
                      to="/FLCSchedule"
                      selected={selected}
                      setSelected={setSelected}
                    /> */}

                  {/* <Item
                    icon={<TodayIcon />}
                    title="FLC Status"
                    to="/FLCStatus"
                    selected={selected}
                    setSelected={setSelected}
                  /> */}
                  {userRole === "CEO" || userRole === "COF" ? (
                    <Item
                      icon={<TodayIcon />}
                      title="Tentative Election Schedule "
                      to="/TentativeElectionSchedule"
                      selected={selected}
                      setSelected={setSelected}
                    />
                  ) : (
                    ""
                  )}

                  {subtaskcodes.includes("9") === true && (userRole === "CEO" || userRole === "COF") ? (
                    <Item
                      icon={<UploadFileIcon />}
                      title="FLC Preparedness "
                      to="/FLCPrepadness"
                      selected={selected}
                      setSelected={setSelected}
                    />
                  ) : (
                    ""
                  )}
                  {(userRole === "DEO" || (userRole === "DOF") ) && subtaskcodes.includes("9") === true ? (
                    <Item
                      icon={<UploadFileIcon />}
                      title="FLC Preparedness "
                      to="/FLCPrepadnessDEO"
                      selected={selected}
                      setSelected={setSelected}
                    />
                  ) : (
                    ""
                  )}

                  {subtaskcodes.includes("10") === true &&
                  (userRole === "CEO" || userRole === "COF") ? (
                    <Item
                      icon={<TodayIcon />}
                      title="FLC Schedule"
                      to="/CreateNewFLCSchedule"
                      selected={selected}
                      setSelected={setSelected}
                    />
                  ) : (
                    ""
                  )}
                  {(userRole === "DEO") || (userRole === "DOF") ? (
                    <Item
                      icon={<TodayIcon />}
                      title="View FLC List"
                      to="/ViewFLCList"
                      selected={selected}
                      setSelected={setSelected}
                    />
                  ) : (
                    ""
                  )}
                  {/* <Item
                      icon={<TodayIcon />}
                      title="FLC Status"
                      to="/FlcStatus"
                      selected={selected}
                      setSelected={setSelected}
                    /> */}

                  {/* <Item
                      icon={<CallSplitIcon />}
                      title="FLC Process"
                      to="/FLCProcess"
                      selected={selected}
                      setSelected={setSelected}
                    /> */}
                  {/* {subtaskcodes.includes("9") === true ? (    
                      <Item
                      icon={<CallSplitIcon />}
                      title="Annexure12"
                      to="/faq"
                      selected={selected}
                      setSelected={setSelected}
                    />):("")} */}
                </SubMenu>
                ) : (
                    ""
                  )}

                {subtaskcodes.includes("12") === true ? (
                  <SubMenu title="T & A" icon={<ModelTrainingIcon />}>
                    <Item
                      icon={<OnDeviceTrainingIcon />}
                      title="Create T & A"
                      to="/Training"
                      selected={selected}
                      setSelected={setSelected}
                    />
                    <Item
                      icon={<ConnectWithoutContactIcon />}
                      title="T & A List"
                      to="/list_T&A"
                      selected={selected}
                      setSelected={setSelected}
                    />
                  </SubMenu>
                ) : (
                  ""
                )}
                {userRole === "ARO" ? "" :
                <SubMenu title="Randomization" icon={<ShuffleIcon />}>
                  {subtaskcodes.includes("18") === true ? (
                    <Item
                      icon={<RestorePageIcon />}
                      title="Randomization Roll Back "
                      to="/rollback"
                      selected={selected}
                      setSelected={setSelected}
                    />
                  ) : (
                    ""
                  )}

                {userRole === "DEO" || userRole === "DOF" || userRole === "ROP" || userRole === "ROA"? (
                    <Item
                      icon={<ManageAccountsIcon />}
                      title="Candidate Count " 
                      to="/candidateDetails"
                      selected={selected}
                      setSelected={setSelected}
                    />
                  ) : (
                    ""
                  )}

                  {subtaskcodes.includes("13") === true ? (
                    <Item
                      visible={visible}
                      onHide={() => setVisible(false)}
                      icon={<TodayIcon />}
                      title="Schedule Randomization"
                      to="/Create1stRandomizationSchedule"
                      selected={selected}
                      setSelected={setSelected}
                    />
                  ) : (
                    ""
                  )}

                  {/* {subtaskcodes.includes("14") === true ? ( */}
                    {(userRole !== "ROA" && userRole !== 'ROP' && userRole !== 'MFA' && userRole !== 'MFS'  && userRole !== 'MWM' && userRole !== 'WIC') ?(
                      <>
                        <Item
                          visible={visible}
                          onHide={() => setVisible(false)}
                          icon={<TodayIcon />}
                          title="1st Randomization List"
                          to="/firstRandomizationSchedule"
                          selected={selected}
                          setSelected={setSelected}
                        />
                      </>
                      ):""} 
                      {/* ):""} */}
                  {(userRole === "ROA" || userRole === "ROP" || userRole === "ADM" || userRole === "ESU" || userRole === "ECU" || userRole === "SNO" || userRole === "CEO" || userRole === "COF") ? (
                    <Item
                      visible={visible}
                      onHide={() => setVisible(false)}
                      icon={<TodayIcon />}
                      title="2nd Randomization List "
                      to="/SecondRandomizationSchedule"
                      selected={selected}
                      setSelected={setSelected}
                    />
                  ) : (
                    ""
                  )}
               {(userRole=== 'DEO' ||userRole=== 'ROP' || userRole=== 'ROA' || userRole=== 'ESU' || userRole=== 'ECU'  || userRole=== 'ADM'  || userRole=== 'CEO'  || userRole=== 'COF') === true ? (
                    <Item
                      visible={visible}
                      onHide={() => setVisible(false)}
                      icon={<TodayIcon />}
                      title=" Randomization Readiness"
                      to="/RandomizationReadiness"
                      selected={selected}
                      setSelected={setSelected}
                    />
                  ) : (
                    ""
                  )}

                  {/* <Item
                      visible={visible}
                      onHide={() => setVisible(false)}
                      icon={<TodayIcon />}
                      title="AC Allocation"
                      to="acAllocation"
                      selected={selected}

                      setSelected={setSelected}
                    /> */}

                  {/* {subtaskcodes.includes("14") === true || subtaskcodes.includes("15") === true  ? (
                      <Item
                        visible={visible}
                        onHide={() => setVisible(false)}
                        icon={<PublishedWithChangesIcon />}
                        title="Randomization process"
                        to="/FirstRandomizationProcess"
                        selected={selected}
                        setSelected={setSelected}
                      />
                    ) : (
                      ""
                    )} */}

                  {/* {subtaskcodes.includes("15") === true  ? (
                      <Item
                        visible={visible}
                        onHide={() => setVisible(false)}
                        icon={<PublishedWithChangesIcon />}
                        title="Randomization process"
                        to="/SecondRandomizationProcess"
                        selected={selected}
                        setSelected={setSelected}
                      />
                    ) : (
                      ""
                    )} */}
                </SubMenu>
                }
                {/* <SubMenu title="CDP">
                {subtaskcodes.includes("19") === true ? (
                  <Item
                    icon={<FlagCircleIcon />}
                    title="CDP Schedule"
                    to="/Commissioning"
                    selected={selected}
                    setSelected={setSelected}
                  />
                ):("")} */}

                {subtaskcodes.includes("21") === true ? (
                  <Item
                    icon={<FlagCircleIcon />}
                    title="Unit Replacement"
                    to="/UnitReplacement"
                    selected={selected}
                    setSelected={setSelected}
                  />
                ) : (
                  ""
                )}
                {(userRole === "ROP" || userRole === "ROA" || userRole === "DEO" || userRole === "ARO") && (
                  <SubMenu style={{ fontSize: '13px' }} title="Mandatory Verification Of VVPAT" icon={<PlaylistAddCircleIcon />}>
                    <>
                      <Item
                        icon={<AddCircleIcon />}
                        title="Mark" 
                        to="/MandatoryVerificationOfVVPAT"
                        selected={selected}
                        setSelected={setSelected}
                      />
                      <Item
                    icon={<VisibilityIcon />}
                    title="View" 
                    to="/VVPATView"
                    selected={selected}
                    setSelected={setSelected}
                  />
                    </>
                  </SubMenu>
                )}
                
                {(userRole === "CEO"||  userRole === "COF" || userRole === "ECU" || userRole === "ADM") && (
                  <SubMenu style={{ fontSize: '13px' }} title="Mandatory Verification Of VVPAT" icon={<AddTaskIcon />}>
                    <Item
                    icon={<VisibilityIcon />}
                    title="View" 
                    to="/VVPATView"
                    selected={selected}
                    setSelected={setSelected}
                  />
                  </SubMenu>
                )}                
                {userRole === "ESU" || userRole === "ADM" ? (
                  <Item
                    icon={<FlagCircleIcon />}
                    title="Unit Replacement Against SOP"
                    to="/UnitReplacementAgainstSOP"
                    selected={selected}
                    setSelected={setSelected}
                  />
                ) : (
                  ""
                )}
                
                {subtaskcodes.includes("21") === true && userRole !== "ARO" ? (
                  <Item
                    icon={<FlagCircleIcon />}
                    title="Unit Replacement Rollback"
                    to="/UnitReplacementRollback"
                    selected={selected}
                    setSelected={setSelected}
                  />
                ) : (
                  ""
                )}
                {subtaskcodes.includes("21") === true && userRole !== "ARO" ? (
                  <Item
                    icon={<FlagCircleIcon />}
                    title="Reserve NF to Reserve Rollback"
                    to="/NonFunctionalReserveRollback"
                    selected={selected}
                    setSelected={setSelected}
                  />
                ) : (
                  ""
                )}
                {(userRole === 'CEO' || userRole === 'COF' || userRole === 'ADM' || userRole === 'ESU' || userRole === 'ECU' || userRole === 'SNO') && (
                  <SubMenu title="Election Petition" icon={<DevicesOtherIcon />}>
                    {(userRole === 'CEO' || userRole === 'COF') && (
                      <Item
                        icon={<GavelIcon />}
                        title="Election Petition"
                        to="/ElectionPetition"
                        selected={selected}
                        setSelected={setSelected}
                      />
                    )}

                    {(userRole === 'ADM' || userRole === 'ESU' || userRole === 'ECU' || userRole === 'CEO' || userRole === 'COF' || userRole === 'SNO') && (
                      <>
                        <Item
                          icon={<GavelIcon />}
                          title="EP View"
                          to="/ElectionPetitionView"
                          selected={selected}
                          setSelected={setSelected}
                        />
                        <Item
                          icon={<GavelIcon />}
                          title="EP Mark Detailed Report"
                          to="/EPMarkDetailedReport"
                          selected={selected}
                          setSelected={setSelected}
                        />
                      </>
                    )}
                  </SubMenu>
                )}
                <SubMenu title="Others" icon={<DevicesOtherIcon />}>
                  {/* {subtaskcodes.includes("25") === true ? (
                    <> */}
                  {userRole === "DEO" || userRole === "DDO" || userRole === "DOF" || userRole === "WIC" ? (
                    <Item
                      icon={<OpenInBrowserIcon />}
                      title="Change Box ID"
                      to="/ChangeBoxID"
                      selected={selected}
                      setSelected={setSelected}
                    />
                  ) : (
                    ""
                  )}
                  <Item
                    icon={<PublishedWithChangesIcon />}
                    title="Change Unit Status"
                    to="/ChangeUnitStatus"
                    selected={selected}
                    setSelected={setSelected}
                  />
                  {userRole !== "ARO" ? (
                    <Item
                      icon={<PublishedWithChangesIcon />}
                      title="Change Units Warehouse"
                      to="/ChangeUnitWarehouseToWarehouse"
                      selected={selected}
                      setSelected={setSelected}
                    />
                  ) : null}

                  {userRole === "CEO" || userRole === "DEO" || userRole === "COF" || userRole === "DOF" ? (
                    <Item
                      icon={<HowToVoteIcon />}
                      title="Polling Station"
                      to="/PollingStation"
                      selected={selected}
                      setSelected={setSelected}
                    />
                  ) : (
                        ""
                      )}
                    {/* </>
                  ) : (
                    ""
                  )} */}

                  {userRole === "ADM" ? (
                    <>
                      <Item
                        icon={<LockOutlinedIcon />}
                        title="Block Units"
                        to="/BlockUnits"
                        selected={selected}
                        setSelected={setSelected}
                      />
                      <Item
                        icon={<LockOpenOutlinedIcon />}
                        title="Un-Block Units"
                        to="/UnBlockUnits"
                        selected={selected}
                        setSelected={setSelected}
                      />
                      <Item
                        icon={<DeleteForeverOutlinedIcon />}
                        title="Destroy Units"
                        to="/DestroyUnits"
                        selected={selected}
                        setSelected={setSelected}
                      />
                    </>
                  ) : (
                    ""
                  )}
                </SubMenu>
              </SubMenu>
            ) : (
              ""
            )}

{userRole === 'MFA' || userRole==='MWM' ? (
                    <SubMenu
                    title="Unit Management"
                    to="/Unitmanagement"
                    selected={selected}
                    setSelected={setSelected}
                    icon={<AccountTreeIcon />}
                  >
                    <Item
                        icon={<OpenInBrowserIcon />}
                        title="Change Box ID"
                        to="/ChangeBoxID"
                        selected={selected}
                        setSelected={setSelected}
                      />
                      </SubMenu>
                       ) : (
                        ""
                      )}
            {userRole !== "ARO" && 
  maintaskcode.includes("5") && (
    <SubMenu
      title="Support"
      to=""
      selected={selected}
      setSelected={setSelected}
      icon={<ListOutlinedIcon />}
    >
      {subtaskcodes.includes("41") && (
        <Item
          icon={<PostAddOutlinedIcon />}
          title="Register Ticket"
          to="/IssueRequest/CreateIssue"
          selected={selected}
          setSelected={setSelected}
        />
      )}
      {subtaskcodes.includes("43") && (
        <>
          <Item
            icon={<PreviewOutlinedIcon />}
            title="View Ticket"
            to="/IssueRequest/Requestlist"
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            icon={<NotListedLocationIcon />}
            title="FAQ's"
            to="/IssueRequest/FaqPage"
            selected={selected}
            setSelected={setSelected}
          />
        </>
      )}
    </SubMenu>
  )
}

            {maintaskcode.includes("7") === true ? (
              <SubMenu
                title="EVM Consumable Management"
                selected={selected}
                setSelected={setSelected}
                icon={<BallotIcon />}
              >
                <Item
                  icon={<AddShoppingCartIcon />}
                  title="Stock Details"
                  to="/Consumable"
                  selected={selected}
                  setSelected={setSelected}
                />
                <Item
                  icon={<BatterySaverIcon />}
                  title="New Stock Entry"
                  to="/Consumable/NewStockEntry"
                  selected={selected}
                  setSelected={setSelected}
                />
                <Item
                  icon={<Battery0BarIcon />}
                  title="Expired Consumables"
                  to="/Consumable/ExpiredConsumables"
                  selected={selected}
                  setSelected={setSelected}
                />
                <Item
                  icon={<BatteryAlertIcon />}
                  title="Expiring Consumables"
                  to="/Consumable/ExpiringConsumables"
                  selected={selected}
                  setSelected={setSelected}
                />
              </SubMenu>
            ) : (
              ""
            )}

            {maintaskcode.includes("6") === true ? (
              <SubMenu
                title="Other Aggregate Services"
                selected={selected}
                setSelected={setSelected}
                icon={<WebIcon />}
              >
                <Item
                  icon={<TravelExploreIcon />}
                  title="Global Search"
                  to="/GLobalSearch"
                  selected={selected}
                  setSelected={setSelected}
                />
                {/* <Item
                  icon={<ManageHistoryIcon />}
                  title="Logged Users Status"
                  to="/LoggedUsersStatus"
                  selected={selected}
                  setSelected={setSelected}
                /> */}
                {userRole !== "ARO" ? (
                <Item
                  icon={<DriveFileRenameOutlineRoundedIcon />}
                  title="View / Edit Master"
                  to="/vieweditmaster"
                  selected={selected}
                  setSelected={setSelected}
                />
                 ) : null }
                {userRole !== "ARO" ? (
                <Item
                  icon={<ManageHistoryIcon />}
                  title="FLC Status"
                  to="/OAFLCStatus"
                  selected={selected}
                  setSelected={setSelected}
                />
                ) : null }
                {userRole === "ADM" || userRole === "ECU" || userRole === "ESU" || userRole === "MFA" ||
                  userRole === "MOF" ||
                  userRole === "MFS" ||
                  userRole === "MWM"   ?
                 <Item
                  icon={<ManageHistoryIcon />}
                  title="District wise Unit Status"
                  to="/NonFunctionalStatus"
                  selected={selected}
                  setSelected={setSelected}
                />:""}
                <Item
                  icon={<BuildCircleIcon />}
                  title="Repaired Units Details"
                  to="/RepairedUnitsDetails"
                  selected={selected}
                  setSelected={setSelected}
                />
                <Item
                  icon={<ManageHistoryIcon />}
                  title="View Election Schedule Info"
                  to="/ElectionDetails"
                  selected={selected}
                  setSelected={setSelected}
                />
                {/* <Item
                  icon={<ManageHistoryIcon />}
                  title="FLC State wise Status"
                  to="/FLCStetewiseStatus"
                  selected={selected}
                  setSelected={setSelected}
                /> */}
                {userRole === "ADM" || userRole === "ECU" || userRole === "ESU" || userRole === "CEO" || userRole === "COF" || userRole === "DOF" || userRole === "DEO" || userRole === "SNO"   ?
                <Item
                  icon={<ManageHistoryIcon />}
                  title="Randomization Status"
                  to="/OARandomizationStatus"
                  selected={selected}
                  setSelected={setSelected}
                />
                :""}
                {userRole === "ADM" || userRole === "ECU" || userRole === "ESU" || userRole === "CEO" || userRole === "COF" || userRole === "DOF" || userRole === "DEO" || userRole === "ROA"  || userRole === "ROP" || userRole === "SNO"  ?
                <Item
                  icon={<ManageHistoryIcon />}
                  title="Randomization Scanning Status"
                  to="/ScanningStatus"
                  selected={selected}
                  setSelected={setSelected}
                />
                :""}

                {userRole === "ESU" ?
                <Item
                  icon={<ManageHistoryIcon />}
                  title="Randomization checking"
                  to="/RandDuplicateChecking"
                  selected={selected}
                  setSelected={setSelected}
                />
                :""}

{userRole === "ESU" ?
                <Item
                  icon={<ManageHistoryIcon />}
                  title="View UnitReplacement Against SoP"
                  to="/ViewUnitReplacementAgainstSoP"
                  selected={selected}
                  setSelected={setSelected}
                />
                :""}

                {userRole === "DEO"|| userRole === "CEO"|| userRole === "ESU"||userRole === "ADM"||userRole === 'ECU'||userRole === "SNO" ?
                <SubMenu title="EVM Checking & Verification" style={{fontSize:"14px"}} icon={<DevicesOtherIcon />}>
                
               {userRole === "DEO" &&(
               <>
                <Item
                  icon={<ExploreIcon />}
                  title="Select"
                  to="/EVMCheckandVerification"
                  selected={selected}
                  setSelected={setSelected}
                />
                <Item
                  icon={<CompareArrowsIcon />}
                  title="Replace"
                  to="/EVMCandVRemove"
                  selected={selected}
                  setSelected={setSelected}
                />
                <Item
                  icon={<ExploreIcon />}
                  title="Mark"
                  to="/CandVUpdate"
                  selected={selected}
                  setSelected={setSelected}
                />
                <Item
                 icon={<UploadFileIcon/>}
                 title="EVM C&V Completion Certificate"
                //  title="Upload Final Document"
                 to="/EVMViewCandVFinal"
                 selected={selected}
                 setSelected={setSelected}
               />
               </>)}            
                 <Item
                  icon={<VisibilityIcon />}
                  title="View"
                  to="/EVMViewCandV"
                  selected={selected}
                  setSelected={setSelected}
                />
                </SubMenu>
                :""}
                

{(userRole === "ESU" || userId === 'INALL000ECU51' || userId === 'INALL000ECU47' || userId === 'INALL000ECU70' || userId === 'INALL000ECU62' || userId === 'INALL000ECU45' || userId === 'INALL000ECU40') ?
                <Item
                  icon={<ManageHistoryIcon />}
                  title="Get OTP"
                  to="/GetOTP"
                  selected={selected}
                  setSelected={setSelected}
                />
                :""}
                
                {/* <Item
                  icon={<ExploreIcon />}
                  title="Overall Unit Replacement Status"
                  to="/OverallUnitReplacementStatus"
                  selected={selected}
                  setSelected={setSelected}
                /> */}
                {userRole === "ADM" ||
                  userRole === "ECU" ||
                  userRole === "ESU" ||
                  userRole === "CEO" ||
                  userRole === "COF" ||
                  userRole === "SNO" ||
                  userRole === "DOF" ||
                  userRole === "DEO" ||
                  userRole === "DDO" ||
                  userRole === "ROA" ||
                  userRole === "ROP" ?
                  <Item
                    icon={<HistoryIcon />}
                    title="Unit Replacement History"
                    to="/UnitReplacementHistory"
                    selected={selected}
                    setSelected={setSelected}
                  /> : ""
                }
                {userRole === "ADM" ||
                  userRole === "ECU" ||
                  userRole === "ESU" ||
                  userRole === "CEO" ||
                  userRole === "COF" ||
                  userRole === "SNO" ||
                  userRole === "DOF" ||
                  userRole === "DEO" ||
                  userRole === "DDO" ||
                  userRole === "WIC" ||
                  userRole === "ROP" ||
                  userRole === "ROA" ?
                  <Item
                    icon={<HistoryIcon />}
                    title="View Box Info"
                    to="/ViewBoxInfo"
                    selected={selected}
                    setSelected={setSelected}
                  /> : ""
                }
                {/* {userRole !== "ARO" ? (
                <Item
                  icon={<ManageHistoryIcon />}
                  title="EP Status"
                  to="/EPStatus"
                  selected={selected}
                  setSelected={setSelected}
                />
               ) : null } */}
                {userRole === "ADM" || userRole === "ECU" || userRole === "ESU" || userRole === "CEO" || userRole === "COF" || userRole === "DOF" || userRole === "DEO" || userRole === "SNO"   ?
                <Item
                  icon={<ManageHistoryIcon />}
                  title="WareHouse Inspection Status"
                  to="/WarehouseInspectionStatus"
                  selected={selected}
                  setSelected={setSelected}
                />:""}
                {userRole === "ESU" ?
                <Item
                  icon={<ManageHistoryIcon />}
                  title="WareHouse Inspection Create/Update"
                  to="/WarehouseInspectionManage"
                  selected={selected}
                  setSelected={setSelected}
                />:""}
               {userRole === "ADM" || userRole === "ECU" || userRole === "ESU"  ?
               <Item
                icon={<ManageHistoryIcon />}
                title="FLC Non Functional"
                to="/FLCNonFunctional"
                selected={selected}
                setSelected={setSelected}
                />
                :""}
                {userRole === "ADM" || userRole === "ESU" || userRole === 'ECU' ? (
                  <Item
                    icon={<ManageHistoryIcon />}
                    title="Manufacturer dashboard"
                    to="/manufacturerdashboard"
                    selected={selected}
                    setSelected={setSelected}
                  />
                ) : (
                  ""
                )}
                {userRole !== "ARO" ? (
                <Item
                  icon={<ExploreIcon />}
                  title="In Field Data"
                  to="/MapData"
                  selected={selected}
                  setSelected={setSelected}
                />
                ) : null }
                {userRole === "ADM" || userRole === "MFA" ? (
                  <Item
                    icon={<SendTimeExtensionIcon />}
                    title="Dispatched Status"
                    to="/DispatchedUnits"
                    selected={selected}
                    setSelected={setSelected}
                  />
                ) : (
                  ""
                )}
                 {userRole === "MFA" ||
                  userRole === "MOF" ||
                  userRole === "MFS" ||
                  userRole === "MWM" ? (
                  <Item
                    icon={<ManageHistoryIcon />}
                    title="Change Unit WH Location"
                    to="/ChangeWarehouse"
                    selected={selected}
                   setSelected={setSelected}
                  />
                ) : (
                  ""
                )}
                {userRole !== "ARO" ? (
                <Item
                    icon={<QrCode2Icon />}
                    title="BarCode Generator"
                    to="/BarCode"
                    selected={selected}
                    setSelected={setSelected}
                  />
                   ) : null }
                  {userRole === "MFA" ||
                   userRole === "MOF" ||
                   userRole === "MFS" ||
                   userRole === "MWM" ? (
                  <Item
                    icon={<BuildCircleIcon />}
                    title="Upload Repaired Certificate"
                    to="/UploadRepairedCertificate"
                    selected={selected}
                    setSelected={setSelected}
                  /> 
                  ) : (
                  ""
                )}
                  {userRole === "MFA" ||
                   userRole === "MOF" ||
                   userRole === "MFS" ||
                   userRole === "MWM" ? (
                  <Item
                    icon={<PreviewIcon />}
                    title="View Repaired Certificate"
                    to="/viewrepairedcertificate"
                    selected={selected}
                    setSelected={setSelected}
                  /> 
                  ) : (
                  ""
                )}
                  {/* <Item
                    icon={<BuildCircleIcon />}
                    title="View Repaired Certificate"
                    to="/Viewrepairedcertificate"
                    selected={selected}
                    setSelected={setSelected}
                  />  */}
                  
                {/* <SubMenu
                  title="Tracking"
                  selected={selected}
                  setSelected={setSelected}
                  icon={<DirectionsBusFilledIcon />}
                >
                  <Item
                    icon={<AppRegistrationIcon />}
                    title="Personnel Registration"
                    to="/Tracking/personnelRegistration"
                    selected={selected}
                    setSelected={setSelected}
                  /> */}
                  {/* <Item
                    icon={<TrendingUpIcon />}
                    title="Personnel Tracking"
                    to="/Tracking/personnelTracking"
                    selected={selected}
                    setSelected={setSelected}
                  />
                  <Item
                    icon={<ExploreIcon />}
                    title="Vehicle Tracking"
                    to="/Tracking/vehicleTracking"
                    selected={selected}
                    setSelected={setSelected}
                  />
                  <Item
                    icon={<ExploreIcon />}
                    title="Tracking History"
                    to="/Tracking/trackingHistory"
                    selected={selected}
                    setSelected={setSelected}
                  /> */}
                {/* </SubMenu> */}
              </SubMenu>
            ) : (
              <SubMenu
                title="Other Aggregate Services"
                selected={selected}
                setSelected={setSelected}
                icon={<WebIcon />}
              >
                <Item
                  icon={<ManageHistoryIcon />}
                  title="Dispatch Status"
                  to="/DispatchedUnits"
                  selected={selected}
                  setSelected={setSelected}
                />

                {/* <Item icon={<TodayIcon />} title="Master Management Module" to="/MasterManagementModule" selected={selected}
                setSelected={setSelected}  /> */}
              </SubMenu>
            )}

            <SubMenu
              title="Reports"
              selected={selected}
              setSelected={setSelected}
              icon={<AssessmentIcon />}
            >
              {/* <Item icon={<TodayIcon />} title="All Reports" to="/Allreports" selected={selected}
                setSelected={setSelected}  /> */}
                {userRole !== "ARO" ? (
              <Item
                icon={<AssessmentOutlinedIcon />}
                title="User Reports"
                to="/UserReport"
                selected={selected}
                setSelected={setSelected}
              />
              ) : null }
              {userRole !== "ARO" ? (
              <Item
                icon={<AssessmentOutlinedIcon />}
                title="Warehouse Reports"
                to="/WarehouseReport"
                selected={selected}
                setSelected={setSelected}
              />
              ) : null }
              <Item
                icon={<AssessmentOutlinedIcon />}
                title="Unit Reports"
                to="/UnitReport"
                selected={selected}
                setSelected={setSelected}
              />
              {(stateId === "AS" || stateId === "DL") && userRole === "CEO" ? (
              <Item
                icon={<AssessmentOutlinedIcon />}
                title="Archive Unit Reports"
                to="/ArchiveUnitReport"
                selected={selected}
                setSelected={setSelected}
              />
              ) : null }
              {userRole !== "ARO" ? (
              <Item
                icon={<AssessmentOutlinedIcon />}
                title="Order Reports"
                to="/OrderReport"
                selected={selected}
                setSelected={setSelected}
              />
              ) : null }
              {userRole !== "ARO" ? (
              <Item
                icon={<AssessmentOutlinedIcon />}
                title="Issue Report"
                to="/IssueReport"
                selected={selected}
                setSelected={setSelected}
              />
              ) : null }
              {userRole !== "ARO" ? (
              <Item
                icon={<AssessmentOutlinedIcon />}
                title="Consumable Report"
                to="/ConsumableReport"
                selected={selected}
                setSelected={setSelected}
              />
              ) : null }
              {userRole === "MFA" ||
              userRole === "ADM" ||
              userRole === "ESU" ||
              userRole === "MFS" ||
              userRole === "MWM" ||
              userRole === "MOF" ||
              userRole === "ECU" ? (
                <Item
                  icon={<AssessmentOutlinedIcon />}
                  title="Manufacturer Report"
                  to="/ManufacturerReport"
                  selected={selected}
                  setSelected={setSelected}
                />
              ) : (
                ""
              )}
              {userRole === "CEO" ||
              userRole === "DEO" ||
              userRole === "DOF" ||
              userRole === "DDO" ||
              userRole === "COF" ? (
                <Item
                  icon={<AssessmentOutlinedIcon />}
                  title="State Wise Report"
                  to="/StateWiseReport"
                  selected={selected}
                  setSelected={setSelected}
                />
              ) : (
                ""
              )}
            </SubMenu>

            <SubMenu
              title="Admin Utilities"
              selected={selected}
              setSelected={setSelected}
              icon={<SettingsSuggestIcon />}
            >
              {userRole === "ADM" || userRole === 'ESU'?
              <Item
                icon={<FormatListBulletedIcon />}
                title="Announcements"
                to="/AdminUtilities/DisplayAnnouncement"
                selected={selected}
                setSelected={setSelected}
              />:""}
              {userRole ==='MFA' || userRole==='MWM' || userRole === 'MOF' || userRole === "ARO" ? "" :
              <Item
                icon={<FormatListBulletedIcon />}
                title="T&A Master"
                to="/AdminUtilities/T&A_Master"
                selected={selected}
                setSelected={setSelected}
              />}
              <Item
                icon={<FormatListBulletedIcon />}
                title="List of States"
                to="/AdminUtilities/State/Code"
                selected={selected}
                setSelected={setSelected}
              />
              <Item
                icon={<FormatListBulletedIcon />}
                title="List of Districts"
                to="/AdminUtilities/District/Code"
                selected={selected}
                setSelected={setSelected}
              />
              <Item
                icon={<FormatListBulletedIcon />}
                title="List of ACs"
                to="/AdminUtilities/AC/Code"
                selected={selected}
                setSelected={setSelected}
              />
              <Item
                icon={<FormatListBulletedIcon />}
                title="List of PCs"
                to="/AdminUtilities/PC/Code"
                selected={selected}
                setSelected={setSelected}
              />
              <Item
                icon={<FormatListBulletedIcon />}
                title="List of PSs"
                to="/AdminUtilities/PSList"
                selected={selected}
                setSelected={setSelected}
              />
              <Item
                icon={<FormatListBulletedIcon />}
                title="List of WareHouse Types"
                to="/AdminUtilities/WareHouseType"
                selected={selected}
                setSelected={setSelected}
              />
              <Item
                icon={<FormatListBulletedIcon />}
                title="List of Non Functional Types"
                to="/AdminUtilities/DefectiveTypes"
                selected={selected}
                setSelected={setSelected}
              />
              <Item
                icon={<FormatListBulletedIcon />}
                title="List of unit types and model"
                to="/AdminUtilities/unittypesandmodel"
                selected={selected}
                setSelected={setSelected}
              />
            </SubMenu>
            <SubMenu
              title="Download"
              selected={selected}
              setSelected={setSelected}
              icon={<FileDownloadIcon />}
            >
             <Item
                icon={<DownloadForOfflineIcon />}
                title="User Manual"
                to="/UserManual"
                selected={selected}
                setSelected={setSelected}
              />
            </SubMenu>
          </Box>
        </Menu>
      </ProSidebar>
    </Box>
  );
};

export default Sidebar;
